import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { useForm } from "../hooks/useForm";
import { Label } from "./ui/Label";
import Button from "./ui/Button";

import { toastr } from "react-redux-toastr";
import { Input } from "./ui/Input";
import { useEndosoMutation } from "../services/docs";
import { useEffect } from "react";
import { cerrarMenu } from "../features/ui/uiSlice";

export const EndosoComponent = () => {
  const [endosoAction] = useEndosoMutation();
  const dispatch = useDispatch();
  const {
    fi_llamada_id,
    Promass,
    E_mail_Aseg,
    Asegurado,
    ApellidoP_Aseg,
    ApellidoM_Aseg,
    RFC,
    Fecha_Nac,
    Tel_Cas_Aseg,
    Tel_Cel_Aseg,
    Calle_Aseg,
    Num_Ext_Aseg,
    Num_Int_Aseg,
    Estado_Aseg,
    Colonia_Aseg,
    Delegacion_Aseg,
    Ciudad_Aseg,
  } = useSelector((state: RootState) => state.ui);
  useEffect(() => {
    dispatch(cerrarMenu());
  }, []);

  const {
    formulario,
    handleInputChange,
    handleSelectChange,
    handleChangeAll,
    handleTexareChange,
  } = useForm({
    fi_llamada_id: fi_llamada_id,
    fi_tipo_endoso: "",
    Promass: Promass,
    E_mail_Aseg: E_mail_Aseg,
    Asegurado: Asegurado,
    ApellidoP_Aseg: ApellidoP_Aseg,
    ApellidoM_Aseg: ApellidoM_Aseg,
    RFC: RFC,
    Fecha_Nac: Fecha_Nac,
    Tel_Cas_Aseg: Tel_Cas_Aseg,
    Tel_Cel_Aseg: Tel_Cel_Aseg,
    Calle_Aseg: Calle_Aseg,
    Num_Ext_Aseg: Num_Ext_Aseg,
    Num_Int_Aseg: Num_Int_Aseg,
    Estado_Aseg: Estado_Aseg,
    Colonia_Aseg: Colonia_Aseg,
    Delegacion_Aseg: Delegacion_Aseg,
    Ciudad_Aseg: Ciudad_Aseg,
  });

  const generarCancelacion = async () => {
    console.log(formulario);
    if (formulario.fi_tipo_endoso === "") {
      toastr.error("Debe seleccionar un Tipo de Endoso");
      return;
    }
    const resp = await endosoAction({
      ...formulario,
      fi_tipo_endoso: +formulario.fi_tipo_endoso,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        }
        toastr.error(err.message);
        return;
      });
    if (resp) {
      toastr.success(resp.message);
    }
  };

  return (
    <div className="w-full">
      <h1 className="mb-10 rounded-t-xl border-b-2 border-primary py-2 pl-3 text-primary">
        Endoso de Póliza
      </h1>
      <div className="card w-full p-5">
        <h3 className="mb-5 font-bold">Cambiar Datos Sensibles del cliente</h3>
        <div className="mt-2 grid grid-cols-1 gap-x-20 gap-y-2 px-2 sm:grid-cols-2 lg:grid-cols-2">
          <div className="my-5">
            <Label className="my-2" htmlFor="fc_nombre">
              Tipo de Endoso
            </Label>

            <select
              className="focus-visible:ring-ring flex h-12 w-full items-center justify-between rounded border border-gray-light bg-gray-ultra-light px-3 py-2 text-sm ring-primary-ultra-light file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2  disabled:cursor-not-allowed disabled:opacity-50"
              name="fi_tipo_endoso"
              onChange={handleSelectChange}
              value={formulario.fi_tipo_endoso}
            >
              <option value="">Selecciona un tipo de endoso</option>
              <option value="1">Correción Ortografica</option>
              <option value="2">Actualización de datos</option>
            </select>
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Promass">
              Certificado:
            </Label>
            <Input
              type="text"
              name="Promass"
              value={formulario.Promass}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="E_mail_Aseg">
              Correo de Electronico:
            </Label>
            <Input
              type="text"
              name="E_mail_Aseg"
              value={formulario.E_mail_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Contratante">
              Nombre(s)
            </Label>
            <Input
              type="text"
              name="Asegurado"
              value={formulario.Asegurado}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="ApellidoP_Aseg">
              Apellido Paterno
            </Label>
            <Input
              type="text"
              name="ApellidoP_Aseg"
              value={formulario.ApellidoP_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="ApellidoM_Aseg">
              Apellido Materno
            </Label>
            <Input
              type="text"
              name="ApellidoM_Aseg"
              value={formulario.ApellidoM_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="RFC">
              RFC
            </Label>
            <Input
              type="text"
              name="RFC"
              value={formulario.RFC}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Fecha_Nac">
              Fecha de Nacimiento
            </Label>
            <Input
              type="text"
              name="Fecha_Nac"
              value={formulario.Fecha_Nac}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Tel_Cas_Aseg">
              Teléfono de Casa
            </Label>
            <Input
              type="text"
              name="Tel_Cas_Aseg"
              value={formulario.Tel_Cas_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Tel_Cel_Aseg">
              Teléfono Celular
            </Label>
            <Input
              type="text"
              name="Tel_Cel_Aseg"
              value={formulario.Tel_Cel_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Calle_Aseg">
              Calle
            </Label>
            <Input
              type="text"
              name="Calle_Aseg"
              value={formulario.Calle_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Num_Ext_Aseg">
              Número Exterior
            </Label>
            <Input
              type="text"
              name="Num_Ext_Aseg"
              value={formulario.Num_Ext_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Num_Int_Aseg">
              Número Interior
            </Label>
            <Input
              type="text"
              name="Num_Int_Aseg"
              value={formulario.Num_Int_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Estado_Aseg">
              Estado
            </Label>
            <Input
              type="text"
              name="Estado_Aseg"
              value={formulario.Estado_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Colonia_Aseg">
              Colonia
            </Label>
            <Input
              type="text"
              name="Colonia_Aseg"
              value={formulario.Colonia_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Delegacion_Aseg">
              Delegación
            </Label>
            <Input
              type="text"
              name="Delegacion_Aseg"
              value={formulario.Delegacion_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Label className="my-2" htmlFor="Ciudad_Aseg">
              Ciudad
            </Label>
            <Input
              type="text"
              name="Ciudad_Aseg"
              value={formulario.Ciudad_Aseg}
              onChange={handleInputChange}
            />
          </div>
          <div className="my-5">
            <Button onClick={generarCancelacion} className="bg-red-800">
              Generar Endoso
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
